import React, { useEffect, useRef, useState } from "react";
import {
  ConfigData,
  DefaulSorting,
  statusConfig,
} from "./configData";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import SearchIcon from "../../../assets/header/search.svg";
import FilterIcon from "../../../assets/header/filter.svg";
import RefreshIcon from "../../../assets/header/refresh.svg";
import { Reusable_table } from "../../../components/reusableItems/table";
import * as XLSX from 'xlsx';

import "./employee_concern.css";
import { useLocation, useNavigate } from "react-router";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { Filter } from "./filter";
import { fetchAllEmployeeConcernList, fetchEmployeeConcernExportList, updateEmployeeConcernStatus } from "../../../store/employee_concern";
import ExportIcon from "../../../assets/header/export.svg";
import { Search } from "./search";
import { HR_CONNECT_EMPLOYEE_CONCERN_DETAILS } from "../../../routes";
import momentTZ from 'moment-timezone';

export const EmployeeConcernListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { searchQuery } = useLocation();
  const { loading, employee_concern_list } = useSelector((state) => state.employeeConcern);
  const [filterLoading, setFilterLoading] = useState(false);

  const [tempStatus, setTempStatus] = useState("");
  const [showStatus, setShowStatus] = useState(false);

  const [tempId, setTempId] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [tempData, setTempData] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  const [exportLoading, setExportLoading] = useState(false);

  const [searchValue, setSearchValue] = useState({
    submission_no: "",
    submitter_name: "",
  });

  const [filterValue, setFilterValue] = useState({
    updated_on_start: "",
    updated_on_end: "",
    updatedDate: "all",
    created_on_start: "",
    created_on_end: "",
    createdDate: "all",
    status: [],
    related_to: '',
  });


  const [relatedToList, setRelatedToList] = useState([
    "Depot",
    "Interchange Group",
    "Workshop",
    "Department",
    "Station",
    "Running Time",
    "Others"
  ]);


  const userPermissions = getUserPermission();
  const viewPermssion = checkPermission(
    userPermissions,
    "hr_connect.access_employee_concern"
  );

  const getData = async (callback) => {
    const payload = {
      created_on_start: filterValue.createdDate === 'all' ? '' : filterValue.created_on_start,
      created_on_end: filterValue.createdDate === 'all' ? '' : filterValue.created_on_end,
      updated_on_start: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_start,
      updated_on_end: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_end,
      status: filterValue.status.join(','),
      related_to: encodeURIComponent(filterValue.related_to),
      submitter: encodeURIComponent(searchValue.submitter_name),
      submission_no: searchValue.submission_no,
    };
    dispatch(fetchAllEmployeeConcernList(payload)).then((res) => {
      if (res.payload.status_code === 200) {
        setTempData(res.payload.data);
        setFilterLoading(false);
        setShouldFetch(false);

      } else {
        setFilterLoading(false);
        setShouldFetch(false);

        alert(res.payload.Message);
      }
    });

  };

  useEffect(() => {
    getData();
  }, []);

  const RefreshData = () => {
    getData();
  };

  const handleFilterAction = () => {
    setShowFilter(!showFilter);
  };

  const handleSearchAction = () => {
    setShowSearch(!showSearch);
  };



  const exportToXlsx = async () => {
    setExportLoading(true);
    const payload = {
      created_on_start: filterValue.createdDate === 'all' ? '' : filterValue.created_on_start,
      created_on_end: filterValue.createdDate === 'all' ? '' : filterValue.created_on_end,
      updated_on_start: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_start,
      updated_on_end: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_end,
      status: filterValue.status.join(','),
      related_to: encodeURIComponent(filterValue.related_to),
      submitter: encodeURIComponent(searchValue.submitter_name),
      submission_no: searchValue.submission_no,
    };
    dispatch(fetchEmployeeConcernExportList(payload)).then((res) => {
      const rawData = res.payload.data;

      // Function to detect ISO 8601 date string
      const isIsoDateString = (value) =>
        typeof value === "string" &&
        /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);

      // Convert dates inside the array
      const convertDates = (arr) =>
        arr.map((row) =>
          Array.isArray(row)
            ? row.map((cell) =>
              isIsoDateString(cell)
                ? momentTZ(cell).tz("Asia/Singapore").format("DD MMM YYYY, hh:mm A")
                : cell
            )
            : row
        );

      // Convert final data
      const finalData = convertDates(rawData);

      const worksheet = XLSX.utils.aoa_to_sheet(finalData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Concern List");
      XLSX.writeFile(workbook, "Employee_Concern_list.xlsx");
      setExportLoading(false);

    });
  };

  const handleExportAction = () => {
    exportToXlsx();
  };



  const icons = [
    {
      icon: FilterIcon,
      title: "Filter",
      action: handleFilterAction,
    },
    {
      icon: ExportIcon,
      title: "Export",
      action: handleExportAction,
    },
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    {
      icon: SearchIcon,
      title: "Search",
      action: handleSearchAction,
    },
  ];


  const handleTableClick = (type, id) => {
    console.log(type, id);
    if (type === "View Details") {
      navigate(`${HR_CONNECT_EMPLOYEE_CONCERN_DETAILS}?id=${id}`)
    }
    if (type === "Update Status") {
      setTempId(id);
      const filteredData = tempData.filter(item => item.id === id);
      setTempStatus(filteredData[0]?.status);
      setShowStatus(true);
    }

  };

  const updateStatus = () => {
    setShowStatus(false);
    let params = {
      id: tempId,
      status: tempStatus,
    };
    dispatch(
      updateEmployeeConcernStatus({ data: params, id: tempId })
    ).then((res) => {
      if (res.payload.status_code === 200) {
        setTempStatus("");
        setTempId("");
        getData();
      } else {
        alert(res.payload.message);
      }
    });
  };

  const FilterAction = () => {
    setShowFilter(false);
    setSearchValue({
      submission_no: "",
      submitter_name: "",
    })

    setShouldFetch(true);
  };

  const filterClearAction = async () => {
    setShowFilter(false);
    setFilterValue({
      ...filterValue,
      updated_on_start: "",
      updated_on_end: "",
      updatedDate: "all",
      created_on_start: "",
      created_on_end: "",
      createdDate: "all",
      status: [],
      related_to: '',
    });
    setShouldFetch(true);
  };

  const SearchAction = () => {
    setShowSearch(false);

    setFilterValue({
      ...filterValue,
      updated_on_start: "",
      updated_on_end: "",
      updatedDate: "all",
      created_on_start: "",
      created_on_end: "",
      createdDate: "all",
      status: [],
      related_to: '',
    });

    setShouldFetch(true);
  };


  useEffect(() => {
    if (shouldFetch) {
      getData();
      setShouldFetch(false);
    }
  }, [filterValue, shouldFetch]);


  function getFilteredStatus(tempStatus) {
    if (tempStatus === "Closed") {
      return [];
    }

    if (tempStatus === "Investigating") {
      return ["Closed"];
    }

    if (tempStatus === "Submitted") {
      return ["Investigating"];
    }
    return [];
  }

  return (
    <>
      {viewPermssion ? (
        <div className="container">
          <div className="reusable_header_main_box">
            <div className="reusable_header_title">Employee Concern</div>
            <div className="reusable_header_icon_main_box">
              {icons.map((i, id) => {
                if (i.buttonName) {
                  return (
                    <div
                      key={id}
                      className="reusable_header_create_box"
                      onClick={i.action}
                    >
                      {i.buttonName}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={id}
                      className="reusable_header_icon_box"
                      onClick={i.action}
                    >
                      <img src={i.icon} />
                    </div>
                  );
                }
              })}
            </div>
          </div>

          {showStatus && (
            <ShowDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={getFilteredStatus(tempStatus)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}


          {showFilter && (
            <Filter
              setShowFilter={setShowFilter}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
              FilterAction={FilterAction}
              filterClearAction={filterClearAction}
              relatedToList={relatedToList}
            />
          )}

          {showSearch && (
            <Search
              setShowFilter={setShowSearch}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              SearchAction={SearchAction}
            />
          )}

          {exportLoading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100vh - 165px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}


          {loading || searchLoading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100vh - 165px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (
            <>
              <Reusable_table
                key={tempData.map(i => i.status).join("-")}
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                defaultSorting={DefaulSorting}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={
                  "calc(100vh - 220px)"
                }
                maxWidth={"calc(100vw - 240px)"}
              />
            </>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
